import React, { useState } from 'react';
import styled from 'styled-components';

import {
  Grid,
  Icon,
  Sidebar
} from 'semantic-ui-react'


const SideNav = styled(Grid.Column)`
  position: sticky !important;
  top: 0;
  bottom: 0;
  height: 100vh;
  background: #f4f5eb;
  transition: width 0.15s;
  flex-direction: column;
  z-index: 9995;
  overflow-y: auto;
`;

const ButtonContainer = styled.div`
  flex: 0 0;
`;

const ToggleButton = styled.button`
    position: relative;
    float: left;
    width: 64px;
    height: 64px;
    padding: 0;
    margin: 0;
    background-color: transparent;
    background-image: none;
    border: 0;
    border-radius: 0;
    cursor: pointer;
`;

const Content = styled.div`
  flex: 1 1;
  padding-left: 20px;
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
`

export default props => {
  const {
    collapsed,
    toggleCollapsed
  } = props;

  return (
    <React.Fragment>
    <Container>
      <ButtonContainer>
        <ToggleButton  onClick={toggleCollapsed}>
          <Icon name="plus" />
        </ToggleButton>
      </ButtonContainer>
    </Container>

  <Sidebar
    visible={collapsed}
    onHide={() => toggleCollapsed()}
    width='very wide'
    style={{background: 'white', zIndex: 9999}}
    animation='overlay'
  >
    <Content>
      {props.children}
    </Content>
  </Sidebar>
    </React.Fragment>
  );
}